import script from "./SelectedBonuses.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedBonuses.vue?vue&type=script&setup=true&lang=ts"

import "./SelectedBonuses.vue?vue&type=style&index=0&id=6ac56762&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac56762"]])

export default __exports__